<template>
  <div>
    <b-navbar class="z-10" fixed="top" toggleable="lg" type="light" variant="">
      <b-navbar-brand :to="{ name: 'Landing' }">
        <img src="@/assets/landingIcons/logo_chi.svg" v-if="$i18n.locale == 'zh'" />
        <img src="@/assets/landingIcons/logo_eng.svg" v-else />
      </b-navbar-brand>

      <b-navbar-toggle target="">
        <div v-b-toggle.sidebar class="menuicon-width">
          <span class="when-open">
            <img alt="" src="@/assets/landingIcons/menu_closed_red.svg" />
          </span>
          <span class="when-closed">
            <img alt="" src="@/assets/landingIcons/menu_red.svg" />
          </span>
        </div>
      </b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto d-flex flex-end text-right">
          <b-nav-item
            href="https://www.discoverhongkong.com/eng/index.html"
            class="align-self-center nav-dir mr-4 main-theme"
          >
            discoverhongkong.com
          </b-nav-item>
          <b-nav-item class="align-self-center mr-4">
            <a
              v-b-toggle
              href="#download-collapse"
              class="nav-dir"
              @click="scrollToView('.content-top-padding')"
            >
              {{ $t("nav.download") }} PDF</a
            >
          </b-nav-item>
          <b-nav-item class="align-self-center mr-4">
            <a href="#" @click="changeUrl()">
              <div class="nav-dir">
                {{ $t("nav.lang") }}
              </div>
            </a>
          </b-nav-item>
          <b-nav-item class="align-self-center">
            <div v-b-toggle.sidebar class="menuicon-width">
              <span class="when-open">
                <img alt="" src="@/assets/landingIcons/menu_closed_red.svg" />
              </span>
              <span class="when-closed">
                <img alt="" src="@/assets/landingIcons/menu_red.svg" />
              </span>
            </div>
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <b-collapse id="download-collapse" class="download-menu container-fluid position-absolute">
      <div class="container main-theme py-5">
        <div class="row pdf-top-row align-items-center justify-content-between mb-4">
          <div class="col-8 col-md-6">
            <h3>{{ $t("title.download") }}</h3>
          </div>
          <div class="col d-flex justify-content-end align-items-center">
            <div class="word-close d-none d-md-block">
              CLOSE
            </div>
            <div v-b-toggle.download-collapse class="menuicon-width">
              <span>
                <img alt="" src="@/assets/landingIcons/menu_closed_red.svg" />
              </span>
            </div>
          </div>
        </div>
        <div class="row pdf-bot-row" v-if="$i18n.locale == 'zh'">
          <div class="col-sm-12 col-lg-4">
            <DivDownloadHeading :pdfPath="pdfPath.tc.full" :heading="$t('title.downloadFull')" />
            <DivDownloadHeading :pdfPath="pdfPath.tc.cmed" :heading="$t('title.ChairmanMsg&ED')" />
            <DivDownloadHeading :pdfPath="pdfPath.tc.cm" :heading="$t('title.ChairmanMsg')" list />
            <DivDownloadHeading :pdfPath="pdfPath.tc.ed" :heading="$t('title.ED')" list />
          </div>
          <div class="col-sm-12 col-lg-4">
            <DivDownloadHeading :pdfPath="pdfPath.tc.bms" :heading="$t('title.bms')" />
            <DivDownloadHeading
              :pdfPath="pdfPath.tc.support"
              :heading="$t('title.supportToEcon')"
            />
            <DivDownloadHeading :pdfPath="pdfPath.tc.init" :heading="$t('title.init')" />
            <DivDownloadHeading :pdfPath="pdfPath.tc.hh" :heading="$t('title.holiday')" list />
            <DivDownloadHeading :pdfPath="pdfPath.tc.gv" :heading="$t('title.gv')" list />
            <DivDownloadHeading :pdfPath="pdfPath.tc.gearing" :heading="$t('title.gearing')" list />
          </div>
          <div class="col-sm-12 col-lg-4">
            <DivDownloadHeading :pdfPath="pdfPath.tc.aboutUs" :heading="$t('title.aboutUs')" />
            <DivDownloadHeading :pdfPath="pdfPath.tc.award" :heading="$t('title.award')" list />
            <DivDownloadHeading
              :pdfPath="pdfPath.tc.worldwide"
              :heading="$t('title.worldwide')"
              list
            />
            <DivDownloadHeading :pdfPath="pdfPath.tc.corp" :heading="$t('title.corp')" list />
            <DivDownloadHeading :pdfPath="pdfPath.tc.report" :heading="$t('title.report')" list />
          </div>
        </div>
        <div class="row pdf-bot-row" v-else>
          <div class="col-sm-12 col-lg-4">
            <DivDownloadHeading :pdfPath="pdfPath.en.full" :heading="$t('title.downloadFull')" />
            <DivDownloadHeading :pdfPath="pdfPath.en.cmed" :heading="$t('title.ChairmanMsg&ED')" />
            <DivDownloadHeading :pdfPath="pdfPath.en.cm" :heading="$t('title.ChairmanMsg')" list />
            <DivDownloadHeading :pdfPath="pdfPath.en.ed" :heading="$t('title.ED')" list />
          </div>
          <div class="col-sm-12 col-lg-4">
            <DivDownloadHeading :pdfPath="pdfPath.en.bms" :heading="$t('title.bms')" />
            <DivDownloadHeading
              :pdfPath="pdfPath.en.support"
              :heading="$t('title.supportToEcon')"
            />
            <DivDownloadHeading :pdfPath="pdfPath.en.init" :heading="$t('title.init')" />
            <DivDownloadHeading :pdfPath="pdfPath.en.hh" :heading="$t('title.holiday')" list />
            <DivDownloadHeading :pdfPath="pdfPath.en.gv" :heading="$t('title.gv')" list />
            <DivDownloadHeading :pdfPath="pdfPath.en.gearing" :heading="$t('title.gearing')" list />
          </div>
          <div class="col-sm-12 col-lg-4">
            <DivDownloadHeading :pdfPath="pdfPath.en.aboutUs" :heading="$t('title.aboutUs')" />
            <DivDownloadHeading :pdfPath="pdfPath.en.award" :heading="$t('title.award')" list />
            <DivDownloadHeading
              :pdfPath="pdfPath.en.worldwide"
              :heading="$t('title.worldwide')"
              list
            />
            <DivDownloadHeading :pdfPath="pdfPath.en.corp" :heading="$t('title.corp')" list />
            <DivDownloadHeading :pdfPath="pdfPath.en.report" :heading="$t('title.report')" list />
          </div>
        </div>
      </div>
    </b-collapse>

    <b-sidebar
      id="sidebar"
      title="Sidebar with backdrop"
      width="600px"
      z-index="9"
      right
      backdrop
      no-header
      lazy
    >
      <div class="container-fluid bg-img">
        <div class="row main-theme">
          <div class="col menu content-top-padding-nav pl-2 pl-lg-4">
            <div v-b-toggle.collapse-1 class="d-flex flex-row my-2">
              <span class="when-open">
                <img src="@/assets/navbar/btn_closed.png" class="m-lg-1 p-2" />
              </span>
              <span class="when-closed">
                <img src="@/assets/navbar/btn_open.png" class="m-lg-1 p-2" />
              </span>
              <h3 class="align-self-center">
                {{ $t("title.ChairmanMsg&ED") }}
              </h3>
            </div>
            <b-collapse id="collapse-1" class="submenu-padding">
              <router-link :to="{ name: 'Chairman' }">
                <div>{{ $t("title.ChairmanMsg") }}</div>
              </router-link>
              <router-link :to="{ name: 'ED' }">
                <div>{{ $t("title.ED") }}</div>
              </router-link>
            </b-collapse>

            <div class="d-flex flex-row my-2">
              <img src="@/assets/navbar/btn_open.png" class="m-lg-1 p-2 invisible" />
              <router-link :to="{ name: 'BoardMembers' }">
                <h3 class="align-self-center">
                  {{ $t("title.bms") }}
                </h3>
              </router-link>
            </div>

            <div class="d-flex flex-row my-2">
              <img src="@/assets/navbar/btn_open.png" class="m-lg-1 p-2 invisible" />
              <router-link :to="{ name: 'SupportToEconomy' }">
                <h3 class="align-self-center">
                  {{ $t("title.supportToEcon") }}
                </h3>
              </router-link>
            </div>

            <div v-b-toggle.collapse-4 class="d-flex flex-row my-2">
              <span class="when-open">
                <img src="@/assets/navbar/btn_closed.png" class="m-lg-1 p-2" />
              </span>
              <span class="when-closed">
                <img src="@/assets/navbar/btn_open.png" class="m-lg-1 p-2" />
              </span>
              <h3 class="align-self-center">
                {{ $t("title.init") }}
              </h3>
            </div>
            <b-collapse id="collapse-4" class="submenu-padding">
              <router-link :to="{ name: 'Initiatives' }">
                <div>{{ $t("title.init") }}</div>
              </router-link>
              <router-link :to="{ name: 'HolidayAtHome' }">
                <div>{{ $t("title.holiday") }}</div>
              </router-link>
              <router-link :to="{ name: 'GlobalVisibility-MissYouToo' }">
                <div>{{ $t("title.gv") }}</div>
              </router-link>
              <router-link :to="{ name: 'GearingUpTheTrade-Uncease' }">
                <div>{{ $t("title.gearing") }}</div>
              </router-link>
            </b-collapse>

            <div v-b-toggle.collapse-5 class="d-flex flex-row my-2">
              <span class="when-open">
                <img src="@/assets/navbar/btn_closed.png" class="m-lg-1 p-2" />
              </span>
              <span class="when-closed">
                <img src="@/assets/navbar/btn_open.png" class="m-lg-1 p-2" />
              </span>
              <h3 class="align-self-center">
                {{ $t("title.aboutUs") }}
              </h3>
            </div>
            <b-collapse id="collapse-5" class="submenu-padding">
              <a :href="[$i18n.locale == 'zh' ? pdfPath.tc.award : pdfPath.en.award]" download>
                <div>{{ $t("title.award") }}</div>
              </a>
              <router-link :to="{ name: 'Map' }">
                <div>{{ $t("title.worldwide") }}</div>
              </router-link>
              <a :href="[$i18n.locale == 'zh' ? pdfPath.tc.corp : pdfPath.en.corp]" download>
                <div>{{ $t("title.corp") }}</div>
              </a>
              <a :href="[$i18n.locale == 'zh' ? pdfPath.tc.report : pdfPath.en.report]" download>
                <div>{{ $t("title.report") }}</div>
              </a>
            </b-collapse>

            <div class="d-flex flex-row submenu-padding d-block d-lg-none mt-5">
              <a href="https://www.discoverhongkong.com/eng/index.html">
                <div class="nav-dir">discoverhongkong.com</div>
              </a>
            </div>

            <div class="d-flex flex-row submenu-padding d-block d-lg-none">
              <a v-b-toggle href="#download-collapse" @click="scrollToView('.content-top-padding')">
                <div class="nav-dir">{{ $t("nav.download") }} PDF</div></a
              >
            </div>

            <div class="d-flex flex-row submenu-padding d-block d-lg-none">
              <a href="#" @click="changeUrl()">
                <div class="nav-dir">
                  {{ $t("nav.lang") }}
                </div>
              </a>
            </div>
          </div>
          <!-- <div class="col-7 photos content-top-paddingX"> -->
          <!-- <ChairmanThumbnail :chairmanThumbnail="chairmanThumbnail" />
            <InitiativesThumbnail
              :initiativesThumbnail="initiativesThumbnail"
            /> -->
          <!-- </div> -->
        </div>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import DivDownloadHeading from "@/components/Menu/DivDownloadHeading.vue";

export default {
  name: "Navbar",
  components: {
    DivDownloadHeading,
  },
  data() {
    return {
      pdfPath: {
        en: {
          full: "pdf/en/0-Full Report.pdf",
          cmed: "pdf/en/1-1-Chairman's Message & ED's Statement.pdf",
          cm: "pdf/en/1-Chairman's Message.pdf",
          ed: "pdf/en/1-2-Executive Director's Statement.pdf",
          bms: "pdf/en/2-Board Members.pdf",
          support: "pdf/en/3-Our Support To Economy.pdf",
          hh: "pdf/en/4-1-Holiday at Home.pdf",
          gv: "pdf/en/4-2-Global Visibility.pdf",
          gearing: "pdf/en/4-3-Gearing Up the Trade.pdf",
          init: "pdf/en/4-Our Initiatives.pdf",
          award: "pdf/en/5-1-Awards & Achievements.pdf",
          worldwide: "pdf/en/5-2-Worldwide Offices & Representatives.pdf",
          corp: "pdf/en/5-3-Corporate Information.pdf",
          report: "pdf/en/5-4-Independent Auditor's Report.pdf",
          aboutUs: "pdf/en/5-About Us.pdf",
        },
        tc: {
          full: "pdf/tc/0-Full Report.pdf",
          cmed: "pdf/tc/1-1-Chairman's Message & ED's Statement.pdf",
          cm: "pdf/tc/1-Chairman's Message.pdf",
          ed: "pdf/tc/1-2-Executive Director's Statement.pdf",
          bms: "pdf/tc/2-Board Members.pdf",
          support: "pdf/tc/3-Our Support To Economy.pdf",
          hh: "pdf/tc/4-1-Holiday at Home.pdf",
          gv: "pdf/tc/4-2-Global Visibility.pdf",
          gearing: "pdf/tc/4-3-Gearing Up the Trade.pdf",
          init: "pdf/tc/4-Our Initiatives.pdf",
          award: "pdf/tc/5-1-Awards & Achievements.pdf",
          worldwide: "pdf/tc/5-2-Worldwide Offices & Representatives.pdf",
          corp: "pdf/tc/5-3-Corporate Information.pdf",
          report: "pdf/tc/5-4-Independent Auditor's Report.pdf",
          aboutUs: "pdf/tc/5-About Us.pdf",
        },
      },
    };
  },
  computed: {},
  methods: {
    scrollToView(el) {
      let element = document.querySelector(el);
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    },
    // changeLocale() {
    //   let locale = this.$i18n.locale;

    //   if (locale == "en") {
    //     this.$i18n.locale = "zh";
    //   } else {
    //     this.$i18n.locale = "en";
    //   }
    // },
    changeUrl() {
      let url = window.location.href;

      if (url.indexOf("/tc/") > -1) {
        url = url.replace("tc/", "eng/");
      } else if (url.indexOf("/eng/") > -1) {
        url = url.replace("eng/", "tc/");
      } else return;

      window.location.replace(url);
    },
  },
  mounted() {
    // this.$i18n.locale = "zh";
  },
};
</script>

<style lang="scss" scoped>
.collapsed > .when-open,
.not-collapsed > .when-closed {
  display: none;
}
.content-top-padding-nav {
  padding-top: 120px;
}
.navbar {
  box-shadow: 0 0px 10px 2px grey;
  background-color: #fff;
  min-height: 80px;
}
.navbar-brand {
  width: 300px;
}
.navbar-light {
  .navbar-toggler {
    border: none;
  }
}
.nav-dir:hover {
  color: #e81b29;
}
.download-menu {
  z-index: 11;
  background-color: #fff;
  box-shadow: 0 0px 10px 2px grey;
}
.word-close {
  padding-right: 2rem;
  font-size: 1.2rem;
}
.menu {
  h3 {
    margin-bottom: 0;
  }
}
.submenu-padding {
  div {
    padding-left: 50px;
    padding-bottom: 0.3rem;
  }
}
.bg-img {
  background-image: url(../assets/navbar/menu_layer.jpg);
  background-size: cover;
  height: 100%;
}
h3 {
  font-weight: 600;
}
.menuicon-width {
  width: 40px;
}
a {
  color: #e81b29;
  &:hover {
    color: #777777;
    text-decoration: none;
  }
}

@media (max-width: 450px) {
  .navbar-brand {
    width: 60vw;
  }
  .menuicon-width {
    width: 10vw;
  }
  .menu {
    padding-left: 3px;
  }
  .submenu-padding {
    div {
      font-size: 4.5vw;
    }
  }
}
@media (max-width: 600px) {
  .content-top-padding-nav {
    padding-top: 110px;
  }
  .submenu-padding {
    div {
      padding-left: 7.5vw;
      padding-bottom: 0.5rem;
    }
  }
  .menu {
    h3 {
      font-size: 5.2vw;
      margin-bottom: 0;
    }
    img {
      max-width: 7.5vw;
    }
  }
}
</style>
